'use strict';

import React, { Component } from 'react';
import classNames from 'classnames';

import MapOverlay from '../components/mapComponents/MapOverlay';
import MapMain from '../components/mapComponents/MapMain';

class MapContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { menuStatus } = this.props;
    const containerClasses = classNames('map-container', {
      'map-menu--toggle': menuStatus
    });

    return (
      <div className={containerClasses}>
        <MapOverlay
          isMapLoaded={this.props.isMapLoaded}
          loadMapFailed={this.props.loadMapFailed}
          haveResults={this.props.haveResults}
        />
        <MapMain
          mapCenter={this.props.mapCenter}
          markers={this.props.markers}
          polygons={this.props.polygons}
          selectedThemeColor={this.props.selectedThemeColor}
          currentZoom={this.props.currentZoom}
          handleMapCompelted={this.props.handleMapCompelted}
          handleMapDataLoading={this.props.handleMapDataLoading}
          handleReloadMapRequest={this.props.handleReloadMapRequest}
          setGlobalMapApi={this.props.setGlobalMapApi}
          setCurrentZoomLevel={this.props.setCurrentZoomLevel}
          handleReloadEventListRequest={this.props.handleReloadEventListRequest}
        />
      </div>
    );
  }
}

export default MapContainer;

